module.exports = __webpack_public_path__ + "img/Alejandro_Onate.83c82f9f.webp";